import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthCompleteGuard } from './modules/shared/services/guards/auth-complete-guard/auth-complete-guard.service';

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./modules/webpay-process/webpay-process.module').then(
        (m) => m.WebpayProcessModule
      ),
  },
  {
    path: 'redirectLoader',
    loadChildren: () =>
      import(
        './modules/webpay-redirect-loader/webpay-redirect-loader.module'
      ).then((m) => m.WebpayRedirectLoaderModule),
  },
  {
    path: 'complete',
    canLoad: [AuthCompleteGuard],
    loadChildren: () =>
      import(
        './modules/webpay-complete-transaction/webpay-complete-transaction.module'
      ).then((m) => m.WebpayCompleteTransactionModule),
  },
  {
    path: 'cancel',
    canLoad: [AuthCompleteGuard],
    loadChildren: () =>
      import(
        './modules/webpay-complete-transaction/webpay-complete-transaction.module'
      ).then((m) => m.WebpayCompleteTransactionModule),
  },

  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
    loadChildren: () =>
      import('./modules/webpay-process/webpay-process.module').then(
        (m) => m.WebpayProcessModule
      ),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
